export const BankNames = {
  BankLeumi: 10,
  BankIgod: 13,
  BankArabIsrael: 34,
  BankHapoalim: 12,
  BankYahav: 4,
  BankDiscont: 11,
  BankMarcentil: 17,
  BankMizrahi: 20,
  Bankbenleumi: 31,
  BankPagi: 52,
  BankHadoar: 9,
  CitiBank: 22,
  BankMasad: 46,
  Bankotsar: 14,
  BankJerusalem: 54,
};

export const BankIds = {
  10: "BankLeumi",
  13: "BankIgod",
  34: "BankArabIsrael",
  12: "BankHapoalim",
  4: "BankYahav",
  11: "BankDiscont",
  17: "BankMarcentil",
  20: "BankMizrahi",
  31: "Bankbenleumi",
  52: "BankPagi",
  9: "BankHadoar",
  22: "CitiBank",
  46: "BankMasad",
  14: "Bankotsar",
  54: "BankJerusalem",
};

export const BankNameAndIds = [
  {
    id: 10,
    name: "BankLeumi",
  },
  {
    id: 13,
    name: "BankIgod",
  },
  {
    id: 34,
    name: "BankArabIsrael",
  },
  {
    id: 12,
    name: "BankHapoalim",
  },
  {
    id: 4,
    name: "BankYahav",
  },
  {
    id: 11,
    name: "BankDiscont",
  },
  {
    id: 17,
    name: "BankMarcentil",
  },
  {
    id: 20,
    name: "BankMizrahi",
  },
  {
    id: 31,
    name: "Bankbenleumi",
  },
  {
    id: 52,
    name: "BankPagi",
  },
  {
    id: 9,
    name: "BankHadoar",
  },
  {
    id: 22,
    name: "CitiBank",
  },
  {
    id: 46,
    name: "BankMasad",
  },
  {
    id: 14,
    name: "Bankotsar",
  },
  {
    id: 54,
    name: "BankJerusalem",
  },
];

